"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_AttributeBasedHealingEventHandlerScript = void 0;
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_AttributeBasedHealingEventHandlerScript = class Effect_AttributeBasedHealingEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.TurnStarted) {
            return;
        }
        const creatorId = handler.args.scriptArgs.creatorId;
        const attribute = container.getMaxAttributeScore(creatorId, handler.args.scriptArgs.attributeType);
        const healingAmount = Math.round(attribute * handler.args.scriptArgs.healingPercent / 100);
        container.applyHealing({
            sequence,
            healerId: creatorId,
            targetId: creatorId,
            amount: healingAmount
        });
    }
};
Effect_AttributeBasedHealingEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_AttributeBasedHealing")
], Effect_AttributeBasedHealingEventHandlerScript);
exports.Effect_AttributeBasedHealingEventHandlerScript = Effect_AttributeBasedHealingEventHandlerScript;
